import { render, staticRenderFns } from "./ResourceInformation.vue?vue&type=template&id=2740e1e1&"
import script from "./ResourceInformation.vue?vue&type=script&lang=ts&"
export * from "./ResourceInformation.vue?vue&type=script&lang=ts&"
import style0 from "./ResourceInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports